/**
 * Which rendered CYP ADHD reports the MDT Review may preview.
 *
 * Adult ADHD's MDT Review reads documents.clinicalinterviewReport and
 * documents.semistructuredinterviewReport. CYP renders into different slots
 * (documents.cypAdhdCiReport, documents.cypAdhdSsiReport) and stores the
 * approval flag on the stage's reportContent doc, not on the adult
 * 6_manageReports tree. Looking up the adult keys leaves the panel empty
 * even after the Clinical Interview and the Semi-Structured Interview have
 * been approved, which is the usual state by the time the MDT meets.
 *
 * A card appears only when both of these are true:
 *   - a PDF was actually stored (a failed PDF export must not offer View);
 *   - that section is currently approved.
 * A section that was approved and then regenerated goes back to "AI outputs
 * ready for review". Its old PDF may no longer match the answers, so it is
 * left off, the same reason the adult panel hides a stale supporting
 * document.
 */

import { STAGE_KEY_TO_CYP_REPORT_STAGE } from '../constants/cypAdhdStages';
import { isPdfReady } from './pdfAvailability';

export const CYP_MDT_SUPPORTING_SLOTS = [
  {
    stageKey: 'clinicalInterview',
    docKey: 'cypAdhdCiReport',
    title: 'Clinical Interview',
    approvedFlag: 'ciReportApproved',
  },
  {
    stageKey: 'semiStructuredInterview',
    docKey: 'cypAdhdSsiReport',
    title: 'Semi-Structured Interview',
    approvedFlag: 'ssiReportApproved',
  },
];

export function getCypMdtSupportingDocuments(documents, reportContent) {
  const docs = documents || {};
  const reports = reportContent || {};
  const available = [];

  CYP_MDT_SUPPORTING_SLOTS.forEach((slot) => {
    const meta = docs[slot.docKey];
    if (!isPdfReady(meta)) return;
    if (reports[slot.stageKey]?.[slot.approvedFlag] !== true) return;
    available.push({
      stageKey: slot.stageKey,
      docKey: slot.docKey,
      title: slot.title,
      // The same string the Documents Dashboard passes to Preview, so View
      // here opens the PDF that was just approved rather than an adult report.
      reportStage: STAGE_KEY_TO_CYP_REPORT_STAGE[slot.stageKey],
      lastGenerated: meta.lastGenerated || null,
    });
  });

  return available;
}
